'use client'

import {createNavigation} from '@/components/layout/createNavigation'
import {Button} from '@/components/ui/button'
import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger} from '@/components/ui/dropdown-menu'
import {Logo} from '@/components/ui/Logo'
import {useTranslations} from '@/i18n/hooks/useTranslations'
import {Link} from '@/i18n/navigation'
import {ChevronDown} from 'lucide-react'
import {LocaleSwitcher} from '../LocaleSwitcher'
import {MobileMenu} from './MobileMenu'

export const Header = () => {
  const t = useTranslations()

  const navigation = createNavigation(t)

  return (
    <header className="bg-white border-b">
      <nav className="container mx-auto h-[72px] flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link href="/" className="inline-block">
            <Logo className="text-[#B50A7A]" />
          </Link>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden lg:flex items-center gap-6">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-1 font-semibold text-gray-900 hover:text-[#B50A7A] data-[state=open]:text-[#B50A7A]">
                  {t('navigation.users')}
                  <ChevronDown className="h-4 w-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="rounded-lg shadow-lg px-4 py-2 space-y-1">
                {navigation.users.links.map((item) => (
                  <DropdownMenuItem key={item.href} asChild>
                    <Link href={item.href} className="font-medium text-sm hover:text-[#B50A7A]">
                      {item.name}
                    </Link>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-1 font-semibold text-gray-900 hover:text-[#B50A7A] data-[state=open]:text-[#B50A7A]">
                  {t('navigation.citiesAndPartners')}
                  <ChevronDown className="h-4 w-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="rounded-lg shadow-lg px-4 py-2 space-y-1">
                {navigation.citiesAndPartners.links.map((item) => (
                  <DropdownMenuItem key={item.href} asChild>
                    {item.external ? (
                      <a className="font-medium text-sm hover:text-[#B50A7A]" href={item.href} target={'_blank'}>
                        {item.name}
                      </a>
                    ) : (
                      <Link href={item.href} className="font-medium text-sm hover:text-[#B50A7A]">
                        {item.name}
                      </Link>
                    )}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>

            <Link href="/support" className="font-semibold text-gray-900 hover:text-[#B50A7A]">
              {t('navigation.support')}
            </Link>
            <LocaleSwitcher />

            <Button asChild className="text-base px-6 py-6 font-semibold">
              <Link href="/download">{t('navigation.downloadApp')}</Link>
            </Button>
          </div>

          <MobileMenu navigation={navigation} />
        </div>
      </nav>
    </header>
  )
}
